import script from "./MandiPurchaseForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MandiPurchaseForm.vue?vue&type=script&setup=true&lang=js"

import "./MandiPurchaseForm.vue?vue&type=style&index=0&id=ce4a4c3e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce4a4c3e"]])

export default __exports__